'use strict';

export class SearchMapTable {
  constructor() {
    function filterType() {
      var w = $(window).width();
        if(w<576){
            $(document).off("click").on("click",".view-display-id-your_local_community .form-composite-filter .form-checkboxes-filter",function () {
              $(this).next(".form-checkboxes").slideToggle("fast");
              $(this).toggleClass("active");
            })
            $("body").click(function (e) {
              var target = $(e.target);
                if (!target.is(".view-display-id-your_local_community .form-composite-filter .form-checkboxes.bef-checkboxes *") && !target.is(".view-display-id-your_local_community .form-composite-filter .form-checkboxes-filter *") ) {
                  if ($(".view-display-id-your_local_community .form-composite-filter .form-checkboxes.bef-checkboxes").is(":visible")) {
                    $(".view-display-id-your_local_community .form-composite-filter .form-checkboxes.bef-checkboxes").slideUp("fast");
                    $(".view-display-id-your_local_community .form-composite-filter  .form-checkboxes-filter").removeClass("active");
                  }
                }
            });
        }else{
          $(".form-checkboxes[id*='edit-type']").removeClass("active");
          $(".form-checkboxes[id*='edit-type'] .form-checkboxes").removeAttr("style");
        }
      }
      filterType();

      var resizeTimer = null;
      $(window).on("resize",function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function(){
          filterType();
        } , 500);
      })


      Drupal.behaviors.myBehavior = {
        attach: function (context, settings) {
      
          //code starts
          var $pumps = $('.views-field-field-local-group .pumps');
          if($pumps.length){

            $pumps.each((index, element) => {
              var $this = $(element);
              var datasrc = $this.attr('data-src');
              if(datasrc){
                let promise = fetch(datasrc, [])
                .then(response => response.body)
                .then(rb => {
                  const reader = rb.getReader();
                  return new ReadableStream({
                    start(controller) {
                      // The following function handles each data chunk
                      function push() {
                        // "done" is a Boolean and value a "Uint8Array"
                        reader.read().then( ({done, value}) => {
                          // If there is no more data to read
                          if (done) {
                            controller.close();
                            return;
                          }
                          // Get the data and send it to the browser via the controller
                          controller.enqueue(value);
                          push();
                        })
                      }
                      push();
                    }
                  });
                })
                .then(stream => {
                  // Respond with our stream
                  return new Response(stream, { headers: { "Content-Type": "text/html" } }).text();
                })
                .then(result => {
                  // Do things with result
                  var pumps = JSON.parse(result);
                  var html = "";
                  pumps.forEach(pump => {
                    html = html + "<p>" + pump.counts + " x " + pump.type + "</p>";
                  });
                  $this.html(html);
                  
                });
              }
            });
          }

          if(!$('.view-display-id-your_local_community > fieldset.fieldgroup.form-composite[data-drupal-selector="edit-type"]').length){
            var $filters = $('.view-display-id-your_local_community > .view-filters fieldset.fieldgroup.form-composite[data-drupal-selector="edit-type"]')
            var $filtersNew = $filters.clone();
            $filters.remove();
            $filtersNew.insertAfter($('.view-display-id-your_local_community > .view-content'));
            $filtersNew.children('input').addClass('form-checkbox');
          }
        }
      };
    
        
  }
}